import React, { useContext } from 'react';
import { redirectIFrame } from '../../../helpers/iframeHelpers';
import LocaleContext from '../../../constants/localization';

const EditUserGroups = ({
  roles,
  assignedRoles,
  handleAssignedRolesChange,
  links = false,
  ssoGroups,
}) => {
  const LS = useContext(LocaleContext);
  return (
    <>
      <table>
        <thead>
          <tr>
            <th style={{ textAlign: 'left' }} colSpan={2}>
              {LS.manageGroups.internalGroups}
            </th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(roles)?.map(([key, value]) => (
            <tr key={key}>
              <td>
                <input
                  type="checkbox"
                  checked={assignedRoles?.includes(key)}
                  onChange={() => handleAssignedRolesChange(key)}
                />
              </td>
              <td>
                {links ? (
                  <a
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      redirectIFrame(
                        `manageUsers.do?action=showGroupsReact&id=${key}`
                      )
                    }
                  >
                    {value}
                  </a>
                ) : (
                  value
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {ssoGroups && (
        <table>
          <thead>
            <th style={{ textAlign: 'left' }} colSpan={2}>
              {LS.manageGroups.externalGroups}
            </th>
          </thead>
          <tbody>
            {Object.entries(ssoGroups)?.map(([key, value]) => (
              <tr key={key}>
                <td>{value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};

export default EditUserGroups;
